import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsContentfulComponent } from './simple-icons-contentful.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsContentfulComponent ],
    exports:      [ SimpleIconsContentfulComponent ],
    bootstrap:    []
})
export class SimpleIconsContentfulModule {}
